import request from '@/utils/request'

let CityApi = {


      // 设置代理
      setting(data) {
        return request._post('/shop/plus.citys.regiontree/setting', data);
    },
    // 获取设置
    getSettings(data){
        return request._post('/shop/plus.citys.regiontree/getSettings', data);
    },
    /*获取区域树*/
    getTree(data, errorback) {
        return request._post('/shop/plus.citys.Index/getTree', data);
      },
    /*开启代理*/
    open(data) {
        return request._post('/shop/plus.citys.Index/open', data);
    },
}
export default CityApi;



// WEBPACK FOOTER //
// ./src/api/citys.js